
/* MACCHIATO — Dynamic Accordion v3
   Compares last nav item's right edge vs secondary nav's left edge.
   If they overlap or are too close, switch to accordion. */
(function() {
  'use strict';

  var GAP = 15; // minimum px gap between last nav item and buttons

  function check() {
    if (window.innerWidth < 700) return;

    document.body.classList.remove('mac-force-mobile');
    void document.body.offsetWidth;

    var nav = document.querySelector('.header__primary-nav');
    var secondary = document.querySelector('.header__secondary-nav');
    if (!nav || !secondary) return;

    var items = nav.querySelectorAll('.header__primary-nav-item');
    if (!items.length) return;

    var lastItem = items[items.length - 1];
    var lastRight = lastItem.getBoundingClientRect().right;
    var secondaryLeft = secondary.getBoundingClientRect().left;

    if (lastRight > secondaryLeft - GAP) {
      document.body.classList.add('mac-force-mobile');
    }
  }

  function init() { setTimeout(check, 200); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var t;
  window.addEventListener('resize', function() {
    clearTimeout(t);
    t = setTimeout(check, 150);
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function() { setTimeout(check, 100); });
  }
})();

/* Fix dropdown menu link clicks being swallowed by theme JS */
document.addEventListener('click', function(e) {
  var link = e.target.closest('.header__dropdown-menu a[href]');
  if (!link) return;
  var url = link.getAttribute('href');
  if (!url || url === '#') return;
  // Let anchor-only links scroll naturally
  if (url.charAt(0) === '#') {
    var target = document.getElementById(url.substring(1));
    if (target) {
      e.preventDefault();
      e.stopPropagation();
      var details = link.closest('details');
      if (details) details.removeAttribute('open');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    return;
  }
  // For real URLs, force navigation
  e.stopPropagation();
  window.location.href = url;
}, true);
